import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            'name',
            { key: 'code', trans: 'code.task', defaultOperator: 'like' },
        ],
        type: 'input',
        value: [],
    },
];
